import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert, ArrowRight } from "lucide-react";

export default function SetupBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || user.is_admin || !user.setup || user.setup.complete || pathname === "/setup") return null;
  const missing = [!user.setup.abn_ok && "ABN verification", user.setup.needs_stripe && !user.setup.stripe_ok && "Stripe payouts"].filter(Boolean).join(" + ");
  return (
    <Link to="/setup" className="block bg-yellow-400 text-black hover:bg-white transition-colors" data-testid="setup-banner">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-2 flex items-center justify-between gap-3 text-xs font-bold uppercase tracking-widest">
        <span className="flex items-center gap-2 min-w-0"><ShieldAlert className="w-4 h-4 flex-shrink-0" /> <span className="truncate">Browse freely — finish {missing} to {user.role === "builder" ? "post & book" : "apply & get booked"}</span></span>
        <span className="flex items-center gap-1 flex-shrink-0">Finish setup <ArrowRight className="w-3.5 h-3.5" /></span>
      </div>
    </Link>
  );
}
